import { createFileRoute } from '@tanstack/react-router';

import { MyProfile } from '#modules/user/features/profile/components/MyProfile';

export const Route = createFileRoute('/{-$locale}/_layout/_dashboard/_authed/dashboard/profile')({
  component: MyProfile,
});
